import { Link } from 'react-router-dom';

interface BundleItem {
  id: string;
  name: string;
  imageUrl: string;
  quantity: number;
  urlSlug?: string;
}

interface BundleIncludesSectionProps {
  items: BundleItem[];
}

export const BundleIncludesSection = ({ items }: BundleIncludesSectionProps) => {
  if (items.length === 0) return null;

  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">
        What's Included
      </h3>
      <div className="grid grid-cols-2 gap-3">
        {items.map((item) => (
          <Link
            key={item.id}
            to={`/product/${item.urlSlug || item.id}`}
            className="group rounded-xl border bg-card overflow-hidden hover:shadow-md transition-all"
          >
            <div className="aspect-square bg-muted/30 overflow-hidden">
              <img
                src={item.imageUrl}
                alt={item.name}
                className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300"
                onError={(e) => { e.currentTarget.src = '/placeholder.svg'; }}
              />
            </div>
            <div className="p-2.5">
              <p className="text-sm font-medium text-foreground leading-tight line-clamp-2">
                {item.name}
              </p>
              {item.quantity > 1 && (
                <span className="text-xs text-muted-foreground mt-1 block">
                  Qty: {item.quantity}
                </span>
              )}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
